module.exports = __webpack_public_path__ + "img/mp3.e47eada1.svg";